import { ElMessageBox } from 'element-plus/es';
import 'element-plus/es/components/message-box/style/css';
import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.filter.js";
import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, unref as _unref, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, normalizeStyle as _normalizeStyle, resolveDirective as _resolveDirective, withDirectives as _withDirectives } from "vue";
const _hoisted_1 = {
  class: "contract-list-btn"
};
import { computed, onMounted, reactive, ref } from "vue";
import { Edit, Search } from '@element-plus/icons-vue';
import ContractAdd from './components/ContractAdd';
import ContractStatus from './components/ContractStatus';
import ContractInfo from './components/ContractInfo';
import apis from "@/api";
import { ElMessage } from "element-plus";
import { getAreaCodeList } from "../../../api/modules/advert";
export default {
  __name: 'ContractList',
  props: {
    isAdmin: {
      type: Boolean,
      default: false
    }
  },
  setup(__props) {
    const props = __props;
    const headerStyle = ref({
      background: '#FAFAFA'
    });
    const data = reactive({
      queryParam: {
        contractCode: '',
        contractName: '',
        supplier: '',
        areaCode: '',
        statementStatus: ''
      },
      tableData: [],
      pagination: {
        totalSize: 0,
        pageSize: 10,
        pageNo: 1
      },
      areaSelect: [],
      statusSelect: [{
        label: '全部',
        value: ''
      }, {
        label: '待审核',
        value: '1'
      }],
      isProvinceAdmin: false,
      currentContract: {}
    });

    // 如果是省公司管理员，只能操作区域码为'0000'的合同
    const provinceAction = row => {
      if (!data.isProvinceAdmin) {
        return true;
      }
      return row.areaCodeList.indexOf('0000') >= 0;
    };
    const contractAddVisible = ref(false);
    const contractEdit = ref(false);
    const contractTitle = ref('添加合同');
    const contractEditRef = ref();
    const contractInfoVisible = ref(false);
    const contractInfoTitle = ref('合同详情');
    const canProvinceAction = ref(false);
    const contractAction = ref('');
    const adminArea = ref('0000');
    const elLoading = ref(false);
    const tableRowStyle = ({
      row,
      column,
      rowIndex,
      columnIndex
    }) => {
      if (row.expiringDays <= 30) {
        if (column.property === 'contractCode' || column.property === 'contractName' || column.property === 'endDate') {
          return {
            'color': 'red'
          };
        }
      }
      return '';
    };
    const loadData = () => {
      const params = {
        ...data.queryParam,
        ...data.pagination
      };
      elLoading.value = true;
      apis.getContractList(params).then(res => {
        if (res.success) {
          const {
            records,
            size,
            total,
            current
          } = res.data;
          data.tableData = records;
          data.pagination = {
            totalSize: total,
            pageSize: size,
            pageNo: current
          };
        } else {
          ElMessage.error(res.msg);
        }
      }).catch(err => {
        ElMessage.error(err);
      }).finally(() => {
        elLoading.value = false;
      });
    };
    const handleAddContract = () => {
      contractEdit.value = false;
      contractTitle.value = '新增合同';
      contractAddVisible.value = true;
    };
    const handleEditContract = row => {
      contractEdit.value = true;
      contractTitle.value = '修改合同';
      contractEditRef.value.initEdit(row);
      contractAddVisible.value = true;
    };
    const handleSizeChange = val => {
      data.pagination.pageSize = val;
      loadData();
    };
    const handleCurrentChange = val => {
      data.pagination.pageNo = val;
      loadData();
    };
    const handleDelete = row => {
      ElMessageBox.confirm('确定要删除该合同吗？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        const areas = row.areaCodeList.split(',');
        if (areas.length > 1) {
          const newList = areas.filter(e => e !== adminArea.value);
          row.areaCodeList = newList.join(',');
          if (adminArea.value === row.areaCode) {
            row.areaCode = newList[0];
          }
        } else {
          row.status = 0;
        }
        apis.updateContractInfo(row).then(res => {
          if (res.success) {
            if (row.status === 0) {
              apis.deleteContractPersonnelInfo({
                id: row.id
              }).then(res => {
                if (res.success) {
                  ElMessage.success("删除成功!");
                } else {
                  ElMessage.error(res.msg);
                }
              }).catch(err => {
                ElMessage.error(err);
              });
            } else {
              ElMessage.success("删除成功!");
            }
          } else {
            ElMessage.error(res.msg);
          }
        }).catch(err => {
          ElMessage.error(err);
        }).finally(() => {
          loadData();
        });
      });
    };
    const handleView = row => {
      contractAction.value = 'detailView';
      data.currentContract = row;
      contractInfoVisible.value = true;
      canProvinceAction.value = provinceAction(row);
    };
    const handleDetailAudit = row => {
      data.currentContract = row;
      contractAction.value = 'detailAudit';
      contractInfoVisible.value = true;
      canProvinceAction.value = provinceAction(row);
    };
    const handleSettlementAudit = row => {
      data.currentContract = row;
      contractAction.value = 'settlementAudit';
      contractInfoVisible.value = true;
      canProvinceAction.value = provinceAction(row);
    };
    const handleSettlementAdd = row => {
      data.currentContract = row;
      contractAction.value = 'settlementAdd';
      contractInfoVisible.value = true;
      canProvinceAction.value = provinceAction(row);
    };
    const handleDetailAdd = row => {
      data.currentContract = row;
      contractAction.value = 'detailAdd';
      contractInfoVisible.value = true;
      canProvinceAction.value = provinceAction(row);
    };
    onMounted(() => {
      // 判断是否省公司管理员
      apis.rolesOfLogin().then(res => {
        if (res.success) {
          for (let item of res.data) {
            if (item.roleId === 'contract_admin_0000') {
              data.isProvinceAdmin = true;
            }
            if (item.roleId.indexOf('contract_admin_') >= 0) {
              adminArea.value = item.roleId.substring(item.roleId.length - 4);
            }
          }
          apis.getAreaCodeList().then(res => {
            if (res.success) {
              data.areaSelect = res.data;
            }
          });
        } else {
          ElMessage.error('获取角色权限失败！请刷新页面');
        }
      });
      loadData();
    });
    return (_ctx, _cache) => {
      const _component_el_input = _resolveComponent("el-input");
      const _component_el_form_item = _resolveComponent("el-form-item");
      const _component_el_option = _resolveComponent("el-option");
      const _component_el_select = _resolveComponent("el-select");
      const _component_el_button = _resolveComponent("el-button");
      const _component_el_form = _resolveComponent("el-form");
      const _component_el_table_column = _resolveComponent("el-table-column");
      const _component_el_table = _resolveComponent("el-table");
      const _component_el_pagination = _resolveComponent("el-pagination");
      const _directive_loading = _resolveDirective("loading");
      return _openBlock(), _createElementBlock(_Fragment, null, [_createElementVNode("div", null, [_createElementVNode("div", null, [_createVNode(_component_el_form, {
        inline: true
      }, {
        default: _withCtx(() => [_createVNode(_component_el_form_item, {
          label: "合同编码"
        }, {
          default: _withCtx(() => [_createVNode(_component_el_input, {
            modelValue: data.queryParam.contractCode,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => data.queryParam.contractCode = $event),
            placeholder: "请输入合同编码"
          }, null, 8, ["modelValue"])]),
          _: 1
        }), _createVNode(_component_el_form_item, {
          label: "合同名称"
        }, {
          default: _withCtx(() => [_createVNode(_component_el_input, {
            modelValue: data.queryParam.contractName,
            "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => data.queryParam.contractName = $event),
            placeholder: "请输入合同名称"
          }, null, 8, ["modelValue"])]),
          _: 1
        }), _createVNode(_component_el_form_item, {
          label: "供应商"
        }, {
          default: _withCtx(() => [_createVNode(_component_el_input, {
            modelValue: data.queryParam.supplier,
            "onUpdate:modelValue": _cache[2] || (_cache[2] = $event => data.queryParam.supplier = $event),
            placeholder: "请输入供应商"
          }, null, 8, ["modelValue"])]),
          _: 1
        }), __props.isAdmin ? (_openBlock(), _createBlock(_component_el_form_item, {
          key: 0,
          label: "结算单状态"
        }, {
          default: _withCtx(() => [_createVNode(_component_el_select, {
            modelValue: data.queryParam.statementStatus,
            "onUpdate:modelValue": _cache[3] || (_cache[3] = $event => data.queryParam.statementStatus = $event),
            placeholder: "",
            onChange: loadData,
            style: {
              "width": "150px"
            },
            "empty-values": [null, undefined]
          }, {
            default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(data.statusSelect, item => {
              return _openBlock(), _createBlock(_component_el_option, {
                key: item.value,
                label: item.label,
                value: item.value
              }, null, 8, ["label", "value"]);
            }), 128))]),
            _: 1
          }, 8, ["modelValue"])]),
          _: 1
        })) : _createCommentVNode("", true), data.isProvinceAdmin ? (_openBlock(), _createBlock(_component_el_form_item, {
          key: 1,
          label: "地区"
        }, {
          default: _withCtx(() => [_createVNode(_component_el_select, {
            modelValue: data.queryParam.areaCode,
            "onUpdate:modelValue": _cache[4] || (_cache[4] = $event => data.queryParam.areaCode = $event),
            placeholder: "",
            onChange: loadData,
            style: {
              "width": "150px"
            },
            "empty-values": [null, undefined]
          }, {
            default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(data.areaSelect, item => {
              return _openBlock(), _createBlock(_component_el_option, {
                key: item.value,
                label: item.label,
                value: item.value
              }, null, 8, ["label", "value"]);
            }), 128))]),
            _: 1
          }, 8, ["modelValue"])]),
          _: 1
        })) : _createCommentVNode("", true), _createVNode(_component_el_form_item, null, {
          default: _withCtx(() => [_createVNode(_component_el_button, {
            type: "primary",
            icon: _unref(Search),
            onClick: loadData,
            plain: ""
          }, {
            default: _withCtx(() => [...(_cache[8] || (_cache[8] = [_createTextVNode("查询", -1)]))]),
            _: 1
          }, 8, ["icon"]), __props.isAdmin ? (_openBlock(), _createBlock(_component_el_button, {
            key: 0,
            type: "primary",
            icon: _unref(Edit),
            onClick: handleAddContract
          }, {
            default: _withCtx(() => [...(_cache[9] || (_cache[9] = [_createTextVNode("新增合同", -1)]))]),
            _: 1
          }, 8, ["icon"])) : _createCommentVNode("", true)]),
          _: 1
        })]),
        _: 1
      })]), _createElementVNode("div", null, [_withDirectives((_openBlock(), _createBlock(_component_el_table, {
        data: data.tableData,
        style: {
          "width": "100%"
        },
        "header-cell-style": headerStyle.value,
        "cell-style": tableRowStyle,
        border: ""
      }, {
        default: _withCtx(() => [_createVNode(_component_el_table_column, {
          prop: "supplier",
          label: "供应商"
        }), _createVNode(_component_el_table_column, {
          prop: "contractCode",
          label: "合同编码"
        }), _createVNode(_component_el_table_column, {
          prop: "contractName",
          label: "合同名称"
        }), _createVNode(_component_el_table_column, {
          prop: "contractAmount",
          label: "合同金额"
        }), _createVNode(_component_el_table_column, {
          prop: "usedAmount",
          label: "已用金额"
        }), _createVNode(_component_el_table_column, {
          prop: "residueAmount",
          label: "剩余金额"
        }), _createVNode(_component_el_table_column, {
          prop: "startDate",
          label: "合同生效时间"
        }), _createVNode(_component_el_table_column, {
          prop: "endDate",
          label: "合同失效时间"
        }), _createVNode(_component_el_table_column, {
          prop: "settlementState",
          label: "合同清单状态"
        }, {
          default: _withCtx(scope => [_createVNode(_unref(ContractStatus), {
            "settlement-state": scope.row.settlementState
          }, null, 8, ["settlement-state"])]),
          _: 1
        }), _createVNode(_component_el_table_column, {
          label: "操作"
        }, {
          default: _withCtx(scope => [_createElementVNode("div", _hoisted_1, [_createElementVNode("div", null, [_createVNode(_component_el_button, {
            link: "",
            type: "primary",
            size: "small",
            onClick: $event => handleView(scope.row)
          }, {
            default: _withCtx(() => [...(_cache[10] || (_cache[10] = [_createTextVNode("查看", -1)]))]),
            _: 1
          }, 8, ["onClick"])]), _createElementVNode("div", null, [__props.isAdmin && provinceAction(scope.row) ? (_openBlock(), _createBlock(_component_el_button, {
            key: 0,
            link: "",
            type: "primary",
            size: "small",
            onClick: $event => handleEditContract(scope.row)
          }, {
            default: _withCtx(() => [...(_cache[11] || (_cache[11] = [_createTextVNode("修改", -1)]))]),
            _: 1
          }, 8, ["onClick"])) : _createCommentVNode("", true)]), _createElementVNode("div", null, [!props.isAdmin && scope.row.settlementState === 3 || !props.isAdmin && scope.row.settlementState === 1 ? (_openBlock(), _createBlock(_component_el_button, {
            key: 0,
            link: "",
            type: "primary",
            size: "small",
            onClick: $event => handleDetailAdd(scope.row)
          }, {
            default: _withCtx(() => [...(_cache[12] || (_cache[12] = [_createTextVNode("新增合同清单 ", -1)]))]),
            _: 1
          }, 8, ["onClick"])) : _createCommentVNode("", true)]), _createElementVNode("div", null, [__props.isAdmin && scope.row.settlementState === 2 && provinceAction(scope.row) ? (_openBlock(), _createBlock(_component_el_button, {
            key: 0,
            link: "",
            type: "primary",
            size: "small",
            onClick: $event => handleDetailAudit(scope.row)
          }, {
            default: _withCtx(() => [...(_cache[13] || (_cache[13] = [_createTextVNode("合同清单审核 ", -1)]))]),
            _: 1
          }, 8, ["onClick"])) : _createCommentVNode("", true)]), _createElementVNode("div", null, [__props.isAdmin && scope.row.settlementState === 0 && provinceAction(scope.row) ? (_openBlock(), _createBlock(_component_el_button, {
            key: 0,
            link: "",
            type: "primary",
            size: "small",
            onClick: $event => handleSettlementAudit(scope.row),
            style: _normalizeStyle(scope.row.statementStatus === null || scope.row.statementStatus === 0 ? '' : 'color: #e64242')
          }, {
            default: _withCtx(() => [...(_cache[14] || (_cache[14] = [_createTextVNode("合同结算单审核 ", -1)]))]),
            _: 1
          }, 8, ["onClick", "style"])) : _createCommentVNode("", true)]), _createElementVNode("div", null, [!__props.isAdmin && scope.row.settlementState === 0 ? (_openBlock(), _createBlock(_component_el_button, {
            key: 0,
            link: "",
            type: "primary",
            size: "small",
            onClick: $event => handleSettlementAdd(scope.row)
          }, {
            default: _withCtx(() => [...(_cache[15] || (_cache[15] = [_createTextVNode("结算 ", -1)]))]),
            _: 1
          }, 8, ["onClick"])) : _createCommentVNode("", true)]), _createElementVNode("div", null, [__props.isAdmin && provinceAction(scope.row) ? (_openBlock(), _createBlock(_component_el_button, {
            key: 0,
            link: "",
            type: "primary",
            size: "small",
            onClick: $event => handleDelete(scope.row)
          }, {
            default: _withCtx(() => [...(_cache[16] || (_cache[16] = [_createTextVNode("删除 ", -1)]))]),
            _: 1
          }, 8, ["onClick"])) : _createCommentVNode("", true)])])]),
          _: 1
        })]),
        _: 1
      }, 8, ["data", "header-cell-style"])), [[_directive_loading, elLoading.value]])]), _createElementVNode("div", null, [_createVNode(_component_el_pagination, {
        onSizeChange: handleSizeChange,
        onCurrentChange: handleCurrentChange,
        "page-sizes": [10, 20, 50, 100, 200],
        "page-size": data.pagination.pageSize,
        total: data.pagination.totalSize,
        currentPage: data.pagination.pageNo,
        "onUpdate:currentPage": _cache[5] || (_cache[5] = $event => data.pagination.pageNo = $event),
        layout: "total, prev, pager, next, sizes, jumper"
      }, null, 8, ["page-size", "total", "currentPage"])])]), _createVNode(_unref(ContractAdd), {
        ref_key: "contractEditRef",
        ref: contractEditRef,
        visible: contractAddVisible.value,
        "onUpdate:visible": _cache[6] || (_cache[6] = $event => contractAddVisible.value = $event),
        onSuccess: loadData,
        title: contractTitle.value,
        edit: contractEdit.value,
        adminArea: adminArea.value
      }, null, 8, ["visible", "title", "edit", "adminArea"]), _createVNode(_unref(ContractInfo), {
        visible: contractInfoVisible.value,
        "onUpdate:visible": _cache[7] || (_cache[7] = $event => contractInfoVisible.value = $event),
        title: contractInfoTitle.value,
        contract: data.currentContract,
        "is-admin": __props.isAdmin,
        "contract-action": contractAction.value,
        adminArea: adminArea.value,
        onRefresh: loadData,
        provinceAction: canProvinceAction.value
      }, null, 8, ["visible", "title", "contract", "is-admin", "contract-action", "adminArea", "provinceAction"])], 64);
    };
  }
};